import { Link } from "react-router-dom";
import { Instagram, Mail, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-brand-ink text-white/80" data-testid="public-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid gap-12 md:grid-cols-3">
        <div>
          <div className="font-display text-2xl tracking-[0.15em]">PAWS <span className="text-brand-red">N</span> POSES</div>
          <p className="mt-4 text-sm text-white/50 max-w-xs font-serif text-lg leading-relaxed">
            Myofascial release yoga for pets and their parents — taught outdoors in the parks of Salt Lake City.
          </p>
        </div>
        <div className="text-sm space-y-3">
          <div className="text-xs uppercase tracking-[0.3em] text-white/40 mb-4">Explore</div>
          <Link to="/schedule" className="block hover:text-brand-red transition-colors">Park Schedule</Link>
          <Link to="/book" className="block hover:text-brand-red transition-colors">Book a Session</Link>
          <Link to="/login" className="block hover:text-brand-red transition-colors">Owner Login</Link>
        </div>
        <div className="text-sm space-y-3">
          <div className="text-xs uppercase tracking-[0.3em] text-white/40 mb-4">Connect</div>
          <div className="flex items-center gap-3"><MapPin className="w-4 h-4 text-brand-red" /> Salt Lake City, Utah</div>
          <div className="flex items-center gap-3"><Mail className="w-4 h-4 text-brand-red" /> hello@pawsnposesutah.com</div>
          <div className="flex items-center gap-3"><Instagram className="w-4 h-4 text-brand-red" /> @pawsnposesutah</div>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 text-center text-xs text-white/30">
        © {new Date().getFullYear()} Paws N Poses LLC · pawsnposesutah.com
      </div>
    </footer>
  );
}
